var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxesColBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97 11.92C1.67476 12.0974 1.43033 12.348 1.26039 12.6476C1.09045 12.9472 1.00075 13.2856 1 13.63V16.87C1.00075 17.2144 1.09045 17.5528 1.26039 17.8524C1.43033 18.152 1.67476 18.4026 1.97 18.58L4.97 20.38C5.28106 20.5669 5.63711 20.6656 6 20.6656C6.36289 20.6656 6.71894 20.5669 7.03 20.38L11 18V12.5L6 9.5L1.97 11.92V11.92Z",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99977 15.5004L1.25977 12.6504",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.5L11 12.5",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.5V20.67",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5V18L14.97 20.38C15.2811 20.5669 15.6371 20.6656 16 20.6656C16.3629 20.6656 16.7189 20.5669 17.03 20.38L20.03 18.58C20.3252 18.4026 20.5697 18.152 20.7396 17.8524C20.9096 17.5528 20.9992 17.2144 21 16.87V13.63C20.9992 13.2856 20.9096 12.9472 20.7396 12.6476C20.5697 12.348 20.3252 12.0974 20.03 11.92L16 9.5L11 12.5Z",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5L11 12.5",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5004L20.74 12.6504",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5V20.67",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97 3.4196C6.67476 3.59698 6.43033 3.84761 6.26039 4.14719C6.09045 4.44678 6.00075 4.78518 6 5.1296V9.4996L11 12.4996L16 9.4996V5.1296C15.9992 4.78518 15.9096 4.44678 15.7396 4.14719C15.5697 3.84761 15.3252 3.59698 15.03 3.4196L12.03 1.6196C11.7189 1.43272 11.3629 1.33398 11 1.33398C10.6371 1.33398 10.2811 1.43272 9.97 1.6196L6.97 3.4196V3.4196Z",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 7.00039L6.25977 4.15039",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.00039L15.74 4.15039",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5V7",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4L11 1.5L7 4L11 6.5L15 4Z",
    fill: "#1B90FE",
    stroke: "#1B90FE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18V13.5L5.5 15.5V20.5L1.5 18Z",
    fill: "#1B90FE",
    stroke: "#1B90FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20V16L20.5 13.5V17.5L16.5 20Z",
    fill: "#1B90FE",
    stroke: "#1B90FE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxesColBlue);
export default __webpack_public_path__ + "static/media/boxes_col_blue.d2ddaddb85f3f9825cfd83e050dcc97a.svg";
export { ForwardRef as ReactComponent };